import { Polygon } from "@react-google-maps/api"
import { flattenDeep } from "lodash-es"
import React, { useRef, useState } from "react"
import CustomGoogleMap from "components/Organisms/map/CustomGoogleMap"
import MapSwitchControl from "components/Organisms/map/MapSwitchControl"
import AllDCLocations from "components/Templates/AllDCLocations"
import { useAllSurveyAreasPreview } from "graphql/survey-areas/survey-areas.hooks"
import { gisToJson } from "utils/map.utils"
import { Locations } from "utils/symbols.utils"
import SurveyAreaPolygon from "./SurveyAreaPolygon"
import useDCStore from "../dc.store"

const SurveyAreaPreviewMap = ({
  surveyAreaPolygon,
  onPolyComplete,
  enableDrawing,
  onRemove,
}) => {
  const {
    id: distributionCentreId,
    colorCode,
    name,
    address,
    geometry,
  } = useDCStore(store => ({
    id: store.state.basicDetails.id,
    name: store.state.basicDetails.name,
    address: store.state.basicDetails.address,
    colorCode:
      store.state.basicDetails.colorCode?.id ||
      store.state.basicDetails.colorCode,
    geometry: store.state.basicDetails.geometry,
  }))

  const dcAreas = geometry?.coordinates
  const [isSticky, setSticky] = useState(true)
  const mapRef = useRef<any>()

  const [center] = useState(surveyAreaPolygon?.[0])
  const { data } = useAllSurveyAreasPreview(distributionCentreId)

  const surveyAreasUnderDc = data?.allSurveyAreas?.map(c =>
    gisToJson(c.geometry.coordinates[0])
  )

  const convertedDcAreas = dcAreas?.map(a => gisToJson(a[0]))

  const allVertices: any[] =
    flattenDeep(convertedDcAreas).concat(flattenDeep(surveyAreasUnderDc)) ?? []

  function handlePolyComplete(e) {
    onPolyComplete(e)
  }
  return (
    <CustomGoogleMap
      center={center || Locations.Mohadi}
      drawingMode={["polygon"]}
      onLoad={map => {
        mapRef.current = map
      }}
      mapContainerSytle={{
        height: "60vh",
      }}
      onPolyComplete={enableDrawing ? handlePolyComplete : null}
      onCenterMapClicked={e => {
        const bounds = new window.google.maps.LatLngBounds()

        for (const point of allVertices ?? []) {
          if (point.lat && point.lng) {
            bounds.extend(point)
          }
        }

        return mapRef.current?.fitBounds(bounds)
      }}
    >
      <MapSwitchControl
        checked={isSticky}
        onClick={() => setSticky(prev => !prev)}
      />
      {surveyAreaPolygon && (
        <SurveyAreaPolygon
          disableStickyPoints={!isSticky}
          allVertices={allVertices}
          enableDrawing={enableDrawing}
          coordinates={surveyAreaPolygon}
          onChange={e => onPolyComplete({ coordinates: e })}
          onRemove={onRemove}
          colorCode={colorCode}
        />
      )}
      <AllDCLocations
        distributionCentres={[
          {
            id: distributionCentreId,
            geometry: geometry,
            properties: {
              colorCode,
              name,
              address: address as any,
            },
          },
        ]}
      />

      {surveyAreasUnderDc?.map((coords, idx) => {
        return (
          <Polygon
            path={coords}
            key={`preview-area-${idx}`}
            options={{
              strokeOpacity: 0.9,
              strokeWeight: 2,
              fillOpacity: 0.5,
              fillColor: colorCode,
              strokeColor: colorCode,
            }}
          />
        )
      })}
    </CustomGoogleMap>
  )
}

export default SurveyAreaPreviewMap
